/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-lines */
import { useContext, useCallback } from "react";
import { AnalyticsContext, useSessionStorage } from "@swiggy-private/checkout-core";
import {
    impressionRemoveOfferBundleHalfCard,
    clickRemoveOfferBundleHalfCard,
    impressionActiveState,
    impressionNudgeWidget,
    clickNudgeWidget,
    impressionInlineWidget,
    clickInlineWidget,
} from "@cart-client/analytics/events";
import { AUTO_ADD_OR_ONE_TAP_PLAN_TYPE_SESSION_KEY } from "@cart-client/constants/StorageKeys";
import { filterContext } from "@cart-client/helpers/OfferBundle";

export const useOfferBundleAnalytics = () => {
    const { clickEvent, impressionEvent } = useContext(AnalyticsContext);

    const [storedValue] = useSessionStorage(AUTO_ADD_OR_ONE_TAP_PLAN_TYPE_SESSION_KEY, "");

    // analytics handlers
    const impressionHalfCard = useCallback(
        (isM2CFlow?: boolean, onePlanType?: string) => {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const context = JSON.stringify({ one_type: onePlanType });
            impressionRemoveOfferBundleHalfCard(impressionEvent, isM2CFlow, context, storedValue);
        },
        [impressionEvent, storedValue],
    );

    const clickHalfCardConfirm = useCallback(
        (planDetails: string, value: string, isM2CFlow?: boolean) => {
            clickRemoveOfferBundleHalfCard(
                clickEvent,
                filterContext(planDetails, storedValue),
                value,
                isM2CFlow,
                storedValue,
            );
        },
        [clickEvent, storedValue],
    );

    const impressionActiveWidget = useCallback(
        (context: string) => {
            impressionActiveState(impressionEvent, filterContext(context, storedValue), storedValue);
        },
        [impressionEvent, storedValue],
    );

    const impressionNudge = useCallback(
        (context: string) => {
            impressionNudgeWidget(impressionEvent, filterContext(context, storedValue), storedValue);
        },
        [impressionEvent, storedValue],
    );

    const clickNudge = useCallback(
        (context: string, value: string) => {
            clickNudgeWidget(clickEvent, filterContext(context, storedValue), value, storedValue);
        },
        [clickEvent, storedValue],
    );

    const impressionCartInline = useCallback(
        (context: string) => {
            impressionInlineWidget(impressionEvent, filterContext(context, storedValue), storedValue);
        },
        [impressionEvent, storedValue],
    );

    const clickCartInline = useCallback(
        (context: string, value: string) => {
            clickInlineWidget(clickEvent, filterContext(context, storedValue), value, storedValue);
        },
        [clickEvent, storedValue],
    );

    return {
        impressionHalfCard,
        clickHalfCardConfirm,
        impressionActiveWidget,
        impressionNudge,
        clickNudge,
        impressionCartInline,
        clickCartInline,
    };
};
